export default function toMatrix<T>(list: Array<T>, size: number): Array<Array<T>> {
  const res = [];
  for (let i = 0; i < list.length; i += size) {
    res.push(list.slice(i, i + size));
  }
  return res;
}
